"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.CLOSE_BUTTON = exports.CLOSABLE_PAGE_HEADER = void 0;

var _cxs = _interopRequireDefault(require("cxs")),
    _vars = require("../../../common/styles/vars"),
    CLOSABLE_PAGE_HEADER = function CLOSABLE_PAGE_HEADER(a) {
  var b = a.backgroundImage;
  return (0, _cxs["default"])({
    width: "100%",
    position: "fixed",
    top: 0,
    left: 0,
    height: "125px",
    display: "flex",
    flexDirection: "column",
    zIndex: 2,
    backgroundImage: b ? "" : "linear-gradient(to bottom, ".concat(_vars.COLOURS.mono.white, ", ").concat(_vars.COLOURS.mono.white75, ")")
  });
};

exports.CLOSABLE_PAGE_HEADER = CLOSABLE_PAGE_HEADER;

var CLOSE_BUTTON = function CLOSE_BUTTON(a) {
  var b = a.backgroundImage;
  return (0, _cxs["default"])({
    alignSelf: "flex-end",
    marginTop: "22px",
    marginRight: "30px",
    color: b && _vars.COLOURS.mono.white
  });
};

exports.CLOSE_BUTTON = CLOSE_BUTTON;